import FlagBaseIcon, { FlagEmojiIconProps } from "./FlagBaseIcon";

const FrenchFlagEmojiIcon = (props: FlagEmojiIconProps) => {
  return <FlagBaseIcon {...props}>🇫🇷</FlagBaseIcon>;
};

export default FrenchFlagEmojiIcon;
